module.exports = __webpack_public_path__ + "img/4_148.5ef60ed9.png";